const svg4Everybody = require('svg4everybody');

class App {
  init() {
    this.registerPolyfills();
    this.launchPew();
    this.launchSvg4Everybody();
  }

  launchPew() {
    if (window.pew) { window.pew.enhanceRegistry(document); }
  }

  launchSvg4Everybody() {
    svg4Everybody();
  }

  registerPolyfills() {
    if (typeof Object.assign != 'function') {
      Object.assign = function (target) {
        'use strict';
        if (target == null) {
          throw new TypeError('Cannot convert undefined or null to object');
        }

        target = Object(target);
        for (var index = 1; index < arguments.length; index++) {
          var source = arguments[index];
          if (source != null) {
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
        }
        return target;
      };
    }
  }
}

let app = new App();
app.init();



// WEBPACK FOOTER //
// ./web/app/themes/wwp_child_theme/assets/raw/js/app_init.js